// As we don't have access to the product groups in Junip, we have to replicate them here
export const junipProductGroups: Record<string, string[]> = {
  'mitopure-softgels-vegan': [
    'mitopure-softgels-vegan',
    'mitopure-softgels-sample-vegan',
    'mitopure-softgels-refill-vegan',
    'mitopure-softgels',
    'mitopure-softgels-sample',
    'mitopure-softgels-refill',
  ],
  'mitopure-gummies': [
    'mitopure-gummies',
    'mitopure-gummies-sample',
    'mitopure-gummies-refill',
  ],
  'mitopure-powder': [
    'mitopure-powder',
    'mitopure-powder-sample',
    'mitopure-powder-refill',
  ],
  'eye-cream': ['mito-biotic-eye-cream', 'eye-cream'],
  'resurfacing-exfoliator': [
    'resurfacing-exfoliator',
    'resurfacing-exfoliator-mini',
  ],
  'gentle-cleanser': ['gentle-cleanser', 'gentle-cleanser-mini'],
  'barrier-cream': [
    'barrier-cream',
    'barrier-cream-mini',
    'barrier-cream-refill',
    'night-cream',
    'night-cream-trial',
    'night-cream-refill',
  ],
  'firming-serum': [
    'firming-serum',
    'firming-serum-mini',
    'firming-serum-refill',
    'serum',
    'serum-trial',
    'serum-refill',
  ],
  'dewy-cream': [
    'dewy-cream',
    'dewy-cream-mini',
    'dewy-cream-refill',
    'day-cream',
    'day-cream-trial',
    'day-cream-refill',
  ],
};
